<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

    <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden;">
<userLeft :active="15" />
      <div class="box5">
        <div style="overflow: hidden;">
          <div class="box6" style="float: left;">发票详情</div>
        </div>
        <div class="box7"></div>
        <div class="box8">订单信息</div>
        <div class="item">
          <span>订单状态</span>
          <span style="margin-left: 8%;">已完成</span>
        </div>
        <div class="item">
          <span>订单编号</span>
          <span style="margin-left: 8%;">{{obj.orderSn}}</span>
        </div>
        <div class="item">
          <span>开票时间</span>
          <span style="margin-left: 8%;">{{obj.finishedAt}}</span>
        </div>
        <div class="item">
          <span>发票类型</span>
          <span style="margin-left: 8%;">{{obj.invoiceType == 'GENERAL' ? '增值税普通发票' : '增值税专用发票'}}</span>
        </div>

        <div class="box8">发票信息</div>
        <!-- <div class="item">
          <span>发票状态</span>
          <span style="margin-left: 8%; color: #2B9A34;">{{obj.finished ? '已开票' : '未开票'}}</span>
        </div> -->
        <div class="item">
          <span>发票内容</span>
          <span style="margin-left: 8%;">商品明细</span>
        </div>
        <div class="item">
          <span>发票抬头</span>
          <span style="margin-left: 8%;">{{obj.title}}</span>
        </div>
        <div class="item">
          <span>公司税号</span>
          <span style="margin-left: 8%;">{{obj.unifiedSocialCreditCode}}</span>
        </div>
        <div class="box8" style="display:flex;justify-content: space-between;" v-if="obj.receiveTypes === 'ELECTRONIC'">
          <div class="item1" style="text-align: left;">蓝票信息</div>
          <!-- <div class="item1">发票号码</div> -->
          <a v-if="obj.electronic" :href="obj.electronic"  target="_blank">点击查看</a>
          <a v-else style="color: #000"  target="_blank">开票中</a>
          <!-- <div class="item1">发票</div> -->
        </div>
        <div class="box8" style="display:flex;justify-content: space-between;" v-if="obj.receiveTypes === 'ELECTRONIC' && obj.readOrder">
          <div class="item1" style="text-align: left;">红票信息</div>
          <!-- <div class="item1">发票号码</div> -->
          <a v-if="obj.electronic" :href="redPdf"  target="_blank">点击查看</a>
          <a v-else style="color: #000"  target="_blank">开票中</a>
          <!-- <div class="item1">发票</div> -->
        </div>
        <div class="box8" style="display:flex;justify-content: space-between;" v-if="obj.receiveTypes === 'PAPER' && obj.electronic">
          <div class="item1" style="text-align: left;">发票信息</div>
          <div class="item1">发票号码</div>
          <!-- <a :href="obj.electronic"  target="_blank">点击查看</a> -->
          <div class="item1">发票</div>
        </div>
        <div class="box8" style="margin-top: 0; background: #fff;" v-if="obj.electronic && obj.receiveTypes === 'PAPER'">
          <div class="item1" style="text-align: left;">{{obj.invoiceCode}}</div>
          <div class="item1" >{{obj.invoiceNumber}}</div>
          <div class="item1" v-if="obj.electronic && obj.receiveTypes === 'PAPER'"><a-icon type="vertical-align-bottom"/><span>
            <a :href="'/api/file/download/'+ obj.electronic" target="_blank" style="color: #333;">下载</a>/
            <a :href="'/api/file/preview/'+ obj.electronic"  target="_blank" style="color: #999;">查看</a>
            </span></div>
        </div>

          <!-- <div style=";margin-top:5%" v-if="obj.receiveTypes === 'PAPER'"  class="tips_txt">纸质发票已寄出，请注意查收，如有疑问请联系客服！</div> -->
          <div v-if="obj.electronic && obj.receiveTypes === 'PAPER'" style="">
            <div class="tips_txt">快递：{{obj.shippingMethodName ? obj.shippingMethodName : '暂无快递信息'}} 运单号：{{obj.shippingNo ? obj.shippingNo : '暂无运单号信息'}}</div>
              <div class="tips_txt">收件人：{{obj.name}} {{obj.mobile}} {{obj.address}} </div>
          </div>
        <!-- <div v-if="!obj.electronic && obj.receiveTypes === 'PAPER'" class="tips_txt" style="margin-left:30%">注：开票申请已提交至后台管理系统，开票成功后可下载查看！</div> -->
      </div>
    </div>
    <foot/>
  </div>
</template>

<script>
    import axios from "axios";
    import userLeft from "../public/user_left";
    import htmlHeader from "../public/head";
import foot from "../public/foot";
    export default {
        name: "integral",
          components: {
    userLeft,
        htmlHeader,
    foot,
  },
        data() {
            return {
              obj: {},
              redPdf: ''
            };
        },
        methods: {
          get_invoice_details() {
            this.api.get_invoice_details(this.$route.query.uuid).then(res => {
              if(res.ok) {
                this.obj = res.data
                console.log(this.obj, '查询信息')
                if (this.obj.readOrder) {
                  this.api.redPiao(this.obj.readOrder).then((res) => {
                    this.redPdf = res.data.readPdf
                  })
                }
              }else {
                this.$message.error(res.message)
              }
            })
          }
        },
        created() {
          if(this.$route.query.uuid) {
            this.get_invoice_details()
          }
        },
    };
</script>

<style scoped>
  .tips_txt {
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #333333;
margin-top: 1%;
margin-left: 2%;
  }
  .item1 {
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #333333;
width: 33.33%;
text-align: center;
line-height: 40px;
float: left;
height: 40px;
  }
.item {
  width: 100%;
height: 40px;
line-height: 40px;
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #333333;
border: 1px solid #EDE9E9;
padding: 0 2%;
}
    .box8 {
      width: 100%;height: 40px;background: #F4F4F4;
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #333333;
line-height: 40px;
margin-top: 2%;
padding: 0 2%;
    }
    .box7 {
        width: 100%;
        height: 1px;
        border-top: 1px solid #E8E6E6;
        margin-top: 2%;
    }

    .box6 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        /* margin-top: 2%; */
        text-align: left;
    }

.box5 {
        min-height: 1023px;
        width: 80%;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: right;
        margin-top: 2%;
        padding: 2%;
    }



    .box3 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: Regular;
        color: #666666;
        margin-top: 6%;
    }

    .box4 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .box1 {
        width: 220px;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: left;
        margin-top: 2%;
    }

    .box2 {
        width: 100%;
        height: 45px;
        background: #F2F2F2;
    }
</style>



// WEBPACK FOOTER //
// src/components/invoice_details.vue